import React, {useState, useEffect, useRef} from 'react'
import {LoadEffect, TableLoader}  from '../component/loader'
import axios from 'axios'
import { Alerts, WarningModal } from '../component/notify'
import PageHeader from '../component/pageheader'
import {ServerUrl, Token, config, ParentUrl, allowEdit, allowDelete, API_URL} from '../component/include'
import Select from 'react-select'

import {Type} from 'react-bootstrap-table2-editor';
import Cookies from 'js-cookie'
import { useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import cellEditFactory from 'react-bootstrap-table2-editor';
import { Link } from 'react-router-dom'
import { userToken, encrypt } from '../component/authentication'

const Family =()=> {
    const [errors, setErrors] = useState({});
    let myRef = useRef()
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    });
    
    const [family, setFamily] = useState({
        code:'fm'+Math.random().toString(36).substring(2,9),
        familyName:'',
        student:'',
        username:'',
        studentList:[],
        status:'Active'
    })
    const [allFamily, setAllFamily]= useState([])
    //const students  = useSelector(state => state.rootReducer.students);
    
    const [students, setStudents]= useState([])
    const handleFetchAllStudents =()=>{
        setNotice({...notice,  isLoading: true})
    const fd = new FormData();
    let url = API_URL+'/students/index';
    axios.post(url, fd, config).then(result=>{

      if(Array.isArray(result.data.data)){
        setStudents(result.data.data)
    }else{
      setStudents([])
    }

    })
    .catch((error)=>{
        Alerts('Error!', 'danger', error.message)
    }).finally(()=>{
        setNotice({...notice,  isLoading: false})
    })
    }


    const handleChange = event =>{
		const {name, value} = event.target
       setFamily({...family, [name] : value });
       setErrors({...errors, [name]:''});
    }

    const handleDelete = (code)=>{  
        setNotice({...notice,  isLoading: true}) 
           let close =   document.getElementById('btnWarningDialog-'+code)
              close.click();
            let url = API_URL+'/family/delete/'+code;
           axios.get(url, config)
           .then(response =>{
            if(response.data.status ===200){
               Alerts('Saved!', 'success', response.data.message)
                   } else{
               Alerts('Error!', 'danger', response.data.message)
                   }   
           })
           .catch((error)=>{
             Alerts('Error!', 'danger', error.message)
           }).finally(()=>{
              fetchFamily()
               setNotice({...notice, 
                   isLoading: false
               })
           }) 
    }


    const LoginAsParent =(row)=>{

        var inSixtyMinutes = Date.now() + 59 * 60 * 1000;
		var inOneMinutes = Date.now() + 58 * 60 * 1000;
		var inOneHours = new Date(new Date().getTime() + 59 * 60 * 1000);
		let domain = '.aduvieportal.org'
		Cookies.set('_pexpt', inSixtyMinutes, {expires: inOneHours, domain: domain })
			Cookies.set('_pbexpt', inOneMinutes, {expires: inOneHours, domain: domain })

		Cookies.set('tkrspw', row.reset_password, {expires: inOneHours, domain: domain })
		Cookies.set('pkauscd', row.code, {expires: inOneHours, domain: domain })
		Cookies.set('pkamtk', Token,  {expires: inOneHours, domain: domain })   
		Cookies.set('pkarfsh', userToken,  {expires: inOneHours, domain: domain })
		Cookies.set('pkstnm', encrypt(row.familyName),  {expires: inOneHours, domain: domain })

        
        window.open(ParentUrl+'/dashboard', '_blank');

    }

    const getStudentInfo = (code, field) =>{        
        const result = students.filter(list=>list.code===code);
        return   String(result.map(c=>c[field]));
        }



    const modifyFamily =(row)=>{
    
        const stList = JSON.parse(row.studentList)

       let list = []

         for(var i=0; i<stList.length; i++){
             list.push({
                 key:i+1,
                 value:stList[i].code, 
                 label: getStudentInfo(stList[i].code, 'admissionNumber'), 
                 studentName:getStudentInfo(stList[i].code, 'studentName'), 
                 co:getStudentInfo(stList[i].code, 'fatherName'), 
                 phone:getStudentInfo(stList[i].code, 'father_mobile')
             })
         }
      
         setFamily({...family, code:row.code, student:list, username:row.username, familyName:row.familyName}); 
     
         window.scrollTo(0,0);
        }

    const handleStudentName=(cell,row)=>{
        return JSON.parse(cell).map((itm, idx)=>{
            return <div  key={idx}>{getStudent(itm.code)}</div>
        } );
    }
	const getStudent = (code) =>{   
        
         const result = students.filter(list=>list.code===code);
        const answer = result.length!==0?result.map(c=>`(${c.admissionNumber}) ${c.studentName}` ):''

          return  answer;
        }

    const tableHeader = [
        {dataField: 'code', text: 'Action', formatter: (cell, row)=><div>
               {allowDelete==='Yes'?  <a href="#!" data-toggle="modal"  className='btn btn-danger btn-sm'  data-target={`#warningdialog-${cell}`} title="Delete"><i className="icofont icofont-delete-alt"></i></a>:[]}&nbsp; 

            {allowEdit==='Yes'? <button type="button" className="btn btn-warning btn-sm" onClick={()=>modifyFamily(row)} title="Duplicate Class Subject"><i className="fa fa-edit"></i> Modify</button>:[]}

            &nbsp; 

            <a href="#!"   className='btn btn-inverse btn-sm' onClick={()=>LoginAsParent(row)}  title="Login as this Parent"><i className="icofont icofont-login"></i></a> 
<WarningModal message="This is very dangerous, you shouldn't do it! are you really really sure.?" handleAction={()=>handleDelete(cell)} mID={cell} />
        </div>, editable: false},
        {dataField: 'familyName', text: 'Family Name',  sort: true,  validator: (newValue, row, column) => {
            if (!newValue) {
              return {
                valid: false,
                message: 'Family Name is required'
              };
            }
            return true;
          } },
          {dataField: 'username', text: 'Username', editable: false},
        {dataField: 'studentList', text: 'Students', formatter:handleStudentName, editable: false},
        {dataField: 'status',  text: 'Status', editor: {
            type: Type.SELECT, options:[{value:'Active', label:'Active'},
            {value:'Inactive', label:'In Active'}]
          }, formatter:(cell, row)=>row.status==='Active'? <div style={{cursor:'pointer'}} className="text-center"><i title="Double click to change" className="fa fa-check badge-inverse-success"></i></div>: <div style={{cursor:'pointer'}}className="text-center"><i title="Double click to change" className="fa fa-times badge-inverse-danger"></i></div>}       
     ];

    const handleSelect = (option, action)=>{
        
        setFamily({...family, [action.name]: option});
        setErrors({...errors, [action.name]:''})
       
         }

       
         const  fetchFamily =()=>{
            let url = API_URL+'/family/display/all';
            setNotice({...notice,  isLoading: true });
            axios.get(url, config)
            .then(result => {
                setAllFamily(result.data.data)
            })
            .catch((error)=>{
                Alerts('Error!', 'danger', error.message)
            }).finally(()=>{
                setNotice({...notice, isLoading: false
                }); 
            })   
             }


    

     const handleSubmit = event =>{
        event.preventDefault();

        let errors = {};   
		
    if(!family.familyName){
        errors.familyName ='Please enter family name';
    }
    if(!Array.isArray(family.student)){
        errors.student ='Please select student to make family';
       // window.scrollTo(0,0);
    }

     if(Array.isArray(family.student) && family.student.length <1){
        errors.student ='You need at least one or more students to make a family ';
    }   
   
    if(!family.username){
        errors.username ='Please enter username';
    }


    setErrors(errors);


    if(Object.keys(errors).length === 0){
        submit()
    } 
    
}
   

function submit(){  
    var options = family.student;
    var value = [];
    for (var i = 0, l = (options || []).length; i < l; i++) {
      value.push({code:options[i].value});
    }
       const fd = new FormData(); 
       fd.append("jwt", Token);
      fd.append("studentList", JSON.stringify(value, null, 2))
      fd.append("familyName", family.familyName)
      fd.append("username", family.username)
      fd.append("code", family.code)
    setNotice({...notice, isLoading: true}) 

       let url = ServerUrl+'/save_controller/tbl_family'
	  axios.post(url, fd, config)
	  .then(response =>{
        if(response.data.type ==='success'){
            Alerts('Saved!', 'success', response.data.message)
                } else if(response.data.type ==='info'){
                    Alerts('Saved!', 'default', response.data.message)
                        }else{
            Alerts('Error!', 'danger', JSON.stringify(response.data))
                }   
        })
        .catch((error)=>{
            Alerts('Error!', 'danger', error.message)
          }).finally(()=>{
            setFamily({...family, familyName: '', username:'', student:[]}); 
              fetchFamily()
              setNotice({...notice, 
                  isLoading: false
              })
          }) 
}

const ValidateExistence=()=>{
	
	if(family.username!==''){
		const fd = new FormData();
		fd.append("jwt", Token);
		fd.append('data', family.username);
		
		let url = ServerUrl + '/checkExistence/tbl_family/username'
		axios.post(url, fd, config).then(response=>{
			if(response.data===true){
				myRef.current.focus()
				setErrors({...errors, username:family.username+' already choosen'})
				setFamily({...family, username:''});
			}
	  })
	}
}

useEffect(()=>{
    fetchFamily();
},[students]);



useEffect(()=>{
    handleFetchAllStudents()
},[]);


const BasicTable=(props)=>{

    const handleUpdate=(column, newValue, code)=>{       
        const fd = new FormData(); 
        fd.append('newValue', newValue);
        fd.append('column', column.dataField);
        fd.append('code', code);
        let url = API_URL+'/family/change_field'
        axios.post(url, fd, config)
            //.then(result => console.log(result.data))
            .then()
            .catch((error)=>Alerts('Error!', 'danger', error.message)) 
        
       
     } 
  
     const customTotal = (from, to, size) => (
        <span >&nbsp;Showing { from } to { to } of { size } entries</span>
      );
      
const { SearchBar } = Search;
     const options = {
         showTotal: true,
     paginationTotalRenderer: customTotal,
     sizePerPageList: [{text: '50', value: 50}, {text: '100', value: 100}, {text: '250', value: 250},
     { text: 'All', value: props.data.length }]
        
       };
  
     return <React.Fragment>  
    
             <ToolkitProvider search  className="table-responsive"
                 keyField='code' data={ props.data } columns={ props.columns } >
                     
                     {
                         props => (
                         <div >
                           
                             <SearchBar
                             { ...props.searchProps }  className="form-control" placeholder="Type to search!!!" />
                             


                             <BootstrapTable
                             { ...props.baseProps }
                                         striped
                                     hover
                                     condensed
                                     noDataIndication={<div className="alert alert-danger background-danger">No Record Found</div>}
                                 pagination={paginationFactory(options) }
                                 cellEdit={ cellEditFactory({
                                   mode: 'dbclick',
                                   blurToSave: true,
                                   autoSelectText: true,
                         beforeSaveCell: (oldValue, newValue, row, column) => {
                           if(oldValue !==newValue){
                           handleUpdate(column, newValue, row.code);
                           
                          return props.fetchdata;
                         }
                         
                       }
                                 }) }
                             />
                         </div>
                         )
                     }
  </ToolkitProvider>
  </React.Fragment>
  }

  
    
        return (  <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Setup Family">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-home"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><Link to="/students/view_students"> Students</Link></li> 
                    <li className="breadcrumb-item"><a href="#!">Define Family</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">

                <div className="row  ">
								<div className="col-sm-12">
	<div className="card z-depth-0">
		<div className="card-header">
			<h5><i className="fa fa-edit" ></i> Create Family</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
		<div className="card-block">
		<fieldset>
            
            <div className="row">
									
										<section className="col-md-6">


										<div className="form-group">
						<label >Family Name<span style={{color:'red'}}>*</span></label>
						<input type="text" role={'presentation'} autoComplete='off' name="familyName" value={family.familyName} onChange={handleChange} className={errors.familyName  ? 'form-control form-control-danger' : 'form-control'} /> <span style={{color:'red'}}>{errors.familyName && errors.familyName}</span>	
			
												
											</div>
                                            </section>
                                            <section className="col-md-6">
                                            <div className="form-group">
						<label >Username<span style={{color:'red'}}>*</span></label>
						<input type="text" name="username" value={family.username} role={'presentation'} autoComplete='off'  onBlur={ValidateExistence} ref={myRef} onChange={handleChange} className={errors.username  ? 'form-control form-control-danger' : 'form-control'} /> <span style={{color:'red'}}>{errors.username && errors.username}</span>	
			
												
											</div>

</section>

<section className="col-md-12">
							<div className="form-group">
						<label >Select Student<span style={{color:'red'}}>*</span></label>
						<Select isMulti options={
                            students.map((list, idx)=> {
                               return {key:idx, value: list.code, label: list.admissionNumber, studentName:list.studentName, co:list.fatherName, phone:list.father_mobile  }
                             })} 
                        getOptionLabel={option =>`(${option.label}) ${option.studentName} C/O  ${option.co}  ${option.phone}`}
onChange={handleSelect} className={errors.student ? 'form-control form-control-danger' : ''} name="student" value={family.student}  /> <span style={{color:'red'}}>{errors.student && errors.student}</span>
												
											</div>
											
										</section>
										</div>
										
										</fieldset>

	<footer className="pull-right">
	
	<button type="button" id="submit" onClick={handleSubmit} className="btn btn-primary ">Save</button>
	
								</footer>				
							</div>
							</div>
							</div>
		
	
	

	<div className="col-sm-12">
	<div className="card z-depth-0">
		<div className="card-header">
			<h5> <i className="fa fa-th" ></i> Listing All Family</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
		<div className="card-block">


		<div className="col-md-12 table-responsive">
        
        {notice.isDataFetching ? <TableLoader />:
   <BasicTable data={allFamily}   columns={tableHeader}  />} 
</div>
	</div>
    </div>
</div>

</div>
	
   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
 );
        
}

export default React.memo(Family) 